import React, { useState } from 'react';
import { Sun, Moon } from 'lucide-react';

export default function ThemeToggle() {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('erp_theme');
    if (saved) return saved;
    return (window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
  });
  const toggle = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    document.documentElement.setAttribute('data-theme', next);
    localStorage.setItem('erp_theme', next);
  };
  const isDark = theme === 'dark';
  return (
    <button
      onClick={toggle}
      title={`Switch to ${isDark ? 'light' : 'dark'} theme`}
      data-testid="theme-toggle"
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 6,
        padding: '5px 10px', borderRadius: 999,
        border: '1px solid var(--border, #e2e8f0)',
        background: 'var(--surface-3, #f1f5f9)',
        color: 'var(--text-primary, #0f172a)',
        cursor: 'pointer', fontSize: 11, fontWeight: 700,
        transition: 'background 150ms'
      }}
    >
      {isDark ? <Moon size={12} /> : <Sun size={12} />}
      {isDark ? 'Dark' : 'Light'}
    </button>
  );
}
